interface EyebrowProps {
  label: string;
  light?: boolean;
}

export default function Eyebrow({ label, light = false }: EyebrowProps) {
  return (
    <p className={`flex items-center gap-3 text-[11px] md:text-xs font-medium uppercase tracking-[0.16em] ${light ? 'text-white' : 'text-foreground-950'}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
      {label}
    </p>
  );
}